<template>
  <div id="app" :class="appClass" :style="appStyle">
    <div class="absolute inset-0 bg-black/20"></div>
    <AppHeader />
    <main :class="mainClass">
      <router-view />
    </main>
    <AppFooter />
  </div>
  
</template>

<script>
import AppHeader from './components/Header.vue'
import AppFooter from './components/Footer.vue'

export default {
  name: 'App',
  components: { AppHeader, AppFooter },
  data() {
    return {
      bgImage: '/fond.jpg'
    }
  },
  computed: {
    appClass() {
      return 'min-h-screen bg-cover bg-center bg-no-repeat'
    },
    appStyle() {
      return { backgroundImage: `url('${this.bgImage}')` }
    },
    mainClass() {
      return 'relative z-10'
    }
  }
}
</script>

<style>
#app {
  font-family: 'Inter', system-ui, sans-serif;
}
</style>
